import client from './client'

export default {
  async getRecommendVideoList (type, pageIndex = 0, limit = 10, platform = 'GROOT') {
    const url = '/room/list'
    const res = await client.get(url, {
      params: {
        type,
        page: pageIndex,
        limit
      },
      headers: {
        platform
      }
    })
    return res.data.data
  }
}



// WEBPACK FOOTER //
// ./src/apis/ultron-api/fmList.js